module.exports = __webpack_public_path__ + "static/img/tx005.507b881.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx005.png
// module id = ZACD
// module chunks = 1